import React from 'react'
import { LabsavvyIQLogo } from '@labsavvyapp/components'
import { CLIENTS, HOME, PROFILE, SIGN } from '../../../../config/routes'
import styled from '@emotion/styled'
import { Dropdown } from 'semantic-ui-react'
import { useHistory } from 'react-router'
import { useUserViewModel } from '../../../../viewmodels/user'
import { UserMenu } from './components'

const StyledHeader = styled.header`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 60px;
  background-color: var(--white);
  border-bottom: 1px solid var(--darkWhite);
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  align-content: center;
`

const LogoContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 300px;
  padding-left: 10px;
`

const StyledDropdown = styled(Dropdown)`
  margin-right: 10px;
`

const Image = styled.img`
  width: 100%;
  object-fit: 'contain';
  margin-top: 10px;
  margin-bottom: 10px;
`

const PartnerProjectDropdowns = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
`

const Label = styled.span`
  padding: 0px 5px 0px 10px;
  color: gray;
  font-size: 12px;
`

export const NavigationBar = () => {
  const { push } = useHistory()

  const userViewModel = useUserViewModel()

  const me = userViewModel?.me ?? null
  const selectedPartner = userViewModel?.selectedPartner ?? null
  const isSuperAdmin = userViewModel?.isSuperAdmin ?? false
  const setActiveProjectLoading = userViewModel?.setActiveProjectLoading ?? false
  const partnerOptions = userViewModel?.partnerOptions ?? []
  const projectOptions = userViewModel?.projectOptions ?? []
  const partnerSavingModal = userViewModel?.partnerSavingModal ?? null
  const navLogo = me?.partner?.logo?.url ?? null

  const handleSavePartner = (event: React.SyntheticEvent<HTMLElement>, data: any) => {
    userViewModel?.handleShowSwitchPartnerModalChange(false)
    userViewModel?.showPartnerSavingModal(data.value)
  }

  const handleSwitchProject = async (event: React.SyntheticEvent<HTMLElement>, data: any) => {
    const { value } = data

    const [clients, __, view] = window.location.pathname.slice(1).split('/') // eslint-disable-line no-unused-vars
    if ('clients' === clients && 'view' === view) {
      push(CLIENTS.list)
    }

    try {
      await userViewModel?.setActiveProject({
        variables: { projectId: value },
      })
    } catch {
      userViewModel?.handleShowErrorModalChange(true)
    }
  }

  return (
    <StyledHeader>
      <LogoContainer>{navLogo ? <Image src={navLogo} alt="logo" /> : <LabsavvyIQLogo />}</LogoContainer>
      <PartnerProjectDropdowns>
        <Label>Partner:</Label>
        <StyledDropdown
          selection
          search
          placeholder="Select a Partner"
          value={selectedPartner?._id}
          options={partnerOptions}
          onChange={handleSavePartner}
          disabled={!isSuperAdmin}
        />
        <Label>Project:</Label>
        {projectOptions.length > 0 && (
          <StyledDropdown
            selection
            search
            loading={setActiveProjectLoading}
            options={projectOptions}
            onChange={handleSwitchProject}
            defaultValue={userViewModel?.getInitialProject()}
            value={me?.project?._id}
          />
        )}

        <UserMenu />
        {partnerSavingModal}
      </PartnerProjectDropdowns>
    </StyledHeader>
  )
}
